/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */
import { useEffect, useState } from 'react';
import { CreatorProfileSummary, fetchCreators } from '../../api';

export const useCreatorProfiles = () => {
  const [creators, setCreators] = useState<CreatorProfileSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      setIsLoading(true);
      try {
        const list = await fetchCreators();
        if (isMounted) {
          setCreators(list);
        }
      } catch (err) {
        if (isMounted) {
          setError('Unable to load creator profiles.');
          console.error(err);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return { creators, isLoading, error };
};
